import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosBitrixInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";
import { ISubscription, IBitrixMembership, IBitrixActiveMembershipsResponse } from "./types";
import { subscriptionsMock, ISubscriptionMock } from "../../resources/subscriptionsMock";

export const fetchGetSubscriptions = createAsyncThunk<ISubscription[]>(
  "subscriptions/fetchGetSubscriptions",
  async () => {
    try {
      const response = await axiosBitrixInstance.get<IBitrixActiveMembershipsResponse>(api.subscription.GET_SUBSCRIPTIONS);
      
      const memberships = response.data.activeMemberships || [];
      
      if (!response.data.result || !memberships.length) {
        return [];
      }
      
      const mergedSubscriptions = subscriptionsMock.map((mock: ISubscriptionMock) => {
        const apiData = memberships.find((sub: IBitrixMembership) => sub.membershipId === mock.id);
        
        if (mock.type === 'family') {
          return {
            ...mock,
            basePrice: apiData?.price || mock.basePrice || 0,
            additionalPersonPrice: apiData?.surchargeKid || mock.additionalPersonPrice || 0,
            title: apiData?.membershipName || mock.title,
            isNew: apiData?.isHighlight || mock.isNew,
            isBest: apiData?.isHighlight || mock.isBest,
            discounts: apiData?.discounts || [],
          };
        } else if (mock.type === 'gift') {
          return {
            ...mock,
            price: apiData?.price || mock.basePrice || mock.price || 0,
            basePrice: apiData?.price || mock.basePrice || mock.price || 0,
            title: apiData?.membershipName || mock.title,
            isNew: apiData?.isHighlight || mock.isNew,
            isBest: apiData?.isHighlight || mock.isBest,
            discounts: apiData?.discounts || [],
          };
        } else {
          return {
            ...mock,
            price: apiData?.price || mock.basePrice || mock.price || 0,
            title: apiData?.membershipName || mock.title,
            isNew: apiData?.isHighlight || mock.isNew,
            isBest: apiData?.isHighlight || mock.isBest,
            discounts: apiData?.discounts || [],
          };
        }
      });
      
      const subscriptions: ISubscription[] = mergedSubscriptions.map((mock: any) => {
        const includes: string[] = mock.includes.map((inc: string) => {
          switch (inc) {
            case 'gym': return 'gym';
            case 'pool': return 'hotTub';
            case 'sauna': return 'spa';
            case 'playroom': return 'playroom';
            default: return inc;
          }
        });
        
        let expirationDays = 30;
        const durationLower = mock.duration.toLowerCase();
        if (durationLower.includes('90') || durationLower.includes('3 месяц')) {
          expirationDays = 90;
        } else if (durationLower.includes('1 день') || durationLower.includes('разовое') || durationLower.includes('разовая') || mock.type === 'daily') {
          expirationDays = 1;
        } else if (durationLower.includes('30') || durationLower.includes('1 месяц')) {
          expirationDays = 30;
        }
        
        let discountText = "";
        if (mock.discounts && mock.discounts.length > 0) {
          const discount = mock.discounts[0];
          if (discount.method === "sum") {
            discountText = `Скидка ${discount.value} руб. при продлении в течение ${discount.days} дней`;
          } else if (discount.method === "percent") {
            discountText = `Скидка ${discount.value}% при продлении в течение ${discount.days} дней`;
          }
        }
        
        let subscriptionType: "adult" | "kid" | "family" = "adult";
        if (mock.type === 'child') {
          subscriptionType = "kid";
        } else if (mock.type === 'family') {
          subscriptionType = "family";
        }
        
        const finalPrice = mock.type === 'family' ? (mock.basePrice || 0) : (mock.price || mock.basePrice || 0);
        
        return {
          id: mock.id,
          title: mock.title,
          includes,
          secondary_title: mock.subtitle || "",
          type: subscriptionType,
          price: finalPrice,
          created_at: null,
          updated_at: null,
          external_id: mock.id,
          active: 1,
          is_new_version: mock.isNew ? 1 : 0,
          expiration_text: mock.duration,
          discount_text: discountText,
          cart_expiration_text: mock.duration,
          expiration_days: expirationDays,
          has_discount: mock.discounts && mock.discounts.length > 0 ? 1 : 0,
          sort_order: 0,
          isHighlight: mock.isNew || mock.isBest,
          isGift: mock.type === 'gift',
          surchargeAdult: mock.additionalPersonPrice || 0,
          surchargeKid: mock.additionalPersonPrice || 0,
          discounts: mock.discounts || [],
          subtitle: mock.subtitle,
          durationNote: mock.durationNote,
          visitingHours: mock.visitingHours,
          ageRestriction: mock.ageRestriction,
          basePrice: mock.basePrice,
          additionalPersonPrice: mock.additionalPersonPrice,
          minimumPeople: mock.minimumPeople,
          adultsCount: mock.adultsCount,
          childrenCount: mock.childrenCount,
          totalPrice: mock.totalPrice,
          isNew: mock.isNew,
          isBest: mock.isBest,
          isGroupClassesIncluded: mock.isGroupClassesIncluded,
          minPeopleRequired: mock.minPeopleRequired,
          requiresAdult: mock.requiresAdult,
          renewalPrice: mock.renewalPrice,
          renewalDays: mock.renewalDays,
          note: mock.note,
          currentQuantity: mock.currentQuantity,
          mockType: mock.type,
        } as ISubscription & { mockType?: 'family' | 'adult' | 'child' | 'daily' | 'gift' };
      });
      
      return subscriptions;
    } catch (error: any) {
      throw error;
    }
  }
);
